<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { getLoginLink, getRegisterLink } from '../useLinks'

const modalOpen = ref(false)

function eventFunction() {
    modalOpen.value = true
}

onMounted(() => {
    const buttons = window.document.querySelectorAll('.please-log-in')
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', eventFunction)
    }
})

onUnmounted(() => {
    const buttons = window.document.querySelectorAll('.please-log-in')
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].removeEventListener('click', eventFunction)
    }
})

function closeIfOutside(e: object) {
    if (!window.document.querySelector('.modal-body').contains(e.target)) {
        modalOpen.value = false
    }
}
</script>

<template>
    <div
        v-if="modalOpen"
        class="modal wrapper-fluid container-sm login-register-modal"
        style="display: block"
        @click="closeIfOutside">
        <div class="modal-body relative mx-auto my-5 bg-white">
            <span
                class="modal-close close-round text-gray-dark align-self-end float-right"
                @click="modalOpen = false"></span>
            <div class="modal-content mx-auto px-4 py-4 text-center">
                <div class="pb-4 pt-4">
                    <a :href="getLoginLink()" class="w100 i-btn i-btn-round i-btn-secondary">{{
                        $t('header.sign_in')
                    }}</a>
                    <p class="small split-line text-gray-dark my-3">{{ $t('header.new_to_invest') }}</p>
                    <a :href="getRegisterLink()" class="w100 i-btn i-btn-sign-in i-btn-round">{{
                        $t('header.register')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import 'login-register-modal.css';
</style>
